import { AxiosWithoutInterceptors, API_TOKEN } from './api';

export const TOKEN_KEY = '@englishbag-token';
export const isAuthenticated = () => localStorage.getItem(API_TOKEN) !== null;

export const getToken = () => localStorage.getItem(TOKEN_KEY);

export const login = (token) => {
  localStorage.setItem(TOKEN_KEY, `JWT ${token}`);
};

export const logout = () => {
  localStorage.removeItem(TOKEN_KEY);
};

export const signIn = (payload) =>
  AxiosWithoutInterceptors.post('/v1/auth/sign-in', payload);

export const checkEmail = (email) =>
  AxiosWithoutInterceptors.get('/v1/auth/check-email', {
    params: { email },
  });

export const checkEmailWithCompany = (email, organizationId) =>
  AxiosWithoutInterceptors.get('/v1/auth/check-email-company', {
    params: { email, organizationId },
  });

export const resetPassword = (payload) =>
  AxiosWithoutInterceptors.patch('/v1/auth/reset-password', payload);

export const recoverPassword = (payload) =>
  AxiosWithoutInterceptors.post('/v1/auth/recover-password', payload);

export const recoverEmail = (payload) =>
  AxiosWithoutInterceptors.post('/v1/auth/recover-email', payload);

export const confirm = (payload) =>
  AxiosWithoutInterceptors.post('/v1/auth/confirm', payload);

export const signUp = (payload) =>
  AxiosWithoutInterceptors.post('/v1/auth/sign-up', payload);

export const createPassword = async (payload, token) => {
  const { data } = await AxiosWithoutInterceptors.post(
    `/v1/password/create/${token}`,
    {
      password: payload,
    }
  );

  return data;
};

export const verifyTokenTfa = async (userId, tfaToken) => {
  return AxiosWithoutInterceptors.post('v1/auth/tfa/verify', {
    userId,
    tfaToken,
  });
};
